import {FACTIONS} from "../constants/factions";

export const FACTION_CAMPAIGN_STATUSES = {
  IN_DEVELOPMENT: 'in_development',
  PLANNED: 'planned',
};

export const FACTION_CAMPAIGN_STATUS_TITLES = {
  [FACTION_CAMPAIGN_STATUSES.IN_DEVELOPMENT]: 'В разработке',
  [FACTION_CAMPAIGN_STATUSES.PLANNED]: 'В планах',
};

// Фракции, сюжетная кампания которых уже в работе. Остальные — «В планах»
export const FACTIONS_WITH_CAMPAIGN_IN_DEVELOPMENT = [
  FACTIONS.HUMANS,
];

// Родительный падеж названий фракций для заголовка «Кампания {кого}»:
// из FACTION_CONFIGS доступно только именительное (name)
export const FACTION_NAME_GENITIVE = {
  [FACTIONS.AQUARS]: 'Акваров',
  [FACTIONS.BEASTMEN]: 'Зверолюдей',
  [FACTIONS.CELECTIALS]: 'Селестиалов',
  [FACTIONS.DARK_ELVES]: 'Темных эльфов',
  [FACTIONS.DEMONS]: 'Демонов',
  [FACTIONS.DOPPLERS]: 'Допплеров',
  [FACTIONS.DRAGONS]: 'Драконов',
  [FACTIONS.DWARVES]: 'Гномов',
  [FACTIONS.ELEMENTALS]: 'Элементалей',
  [FACTIONS.ELVES]: 'Эльфов',
  [FACTIONS.ENLIGHTENED]: 'Просветлённых',
  [FACTIONS.ENTS]: 'Энтов',
  [FACTIONS.FENIX]: 'Феникса',
  [FACTIONS.GIANTS]: 'Великанов',
  [FACTIONS.GOBLINS]: 'Гоблинов',
  [FACTIONS.GREMLINS]: 'Гремлинов',
  [FACTIONS.HUMANS]: 'Людей',
  [FACTIONS.INSECTOIDS]: 'Инсектоидов',
  [FACTIONS.LEPRECHAUNS]: 'Лепреконов',
  [FACTIONS.MUSHROOM_PEOPLE]: 'Гриболюдов',
  [FACTIONS.ORCS]: 'Орков',
  [FACTIONS.RATMEN]: 'Крысолюдов',
  [FACTIONS.SPIRITS]: 'Духов',
  [FACTIONS.SUCCUBES]: 'Суккубов',
  [FACTIONS.TECHNODWARVES]: 'Технодворфов',
  [FACTIONS.UNDEAD]: 'Нежити',
  [FACTIONS.VENTORY]: 'Вентори',
  [FACTIONS.WIZARDS]: 'Магов',
};
